import { FileUploadData, SelectOption } from "@pulseops/common";
import { CancelRiderFormData } from "../cancel-rider";

export namespace CancelRiderFromInceptionForm {
  export type CancelRiderFromInceptionData = CancelRiderFormData.CancelAllRiderForm & {
    fileAttachment: FileUploadData[]
    // suspendAmount: string
    reason: SelectOption
    riderRefundAmount: number
    tempRefundFee: number
  }
}